import {  SKIP_MAILBOX_CREATION } from './types'
import { CHANGE_STEP } from 'h-signup'

function skipMailboxCreation(params, changeToRoute) {
    return (dispatch) => {
        dispatch({
            type: SKIP_MAILBOX_CREATION,
            payload: params
        });
        dispatch({
            type: CHANGE_STEP,
            payload: changeToRoute
        });
    }
}

export default skipMailboxCreation